/**
 * @file Router — маршрутизация Мультисервис SPA
 * @see docs/tz/01-phase-mvp.md §2.1 (Layout + Router)
 *
 * Sprint 1: login, portfolio, dashboard (stub)
 * Sprint 2: project card, edit
 * Sprint 3: reports, dashboard
 * Sprint 5-6: roadmap (gantt), risks, tasks (kanban)
 * Sprint 9-11: team, finance, EVM
 * Sprint 12-14: presale, settings
 */
import { createBrowserRouter, Navigate } from 'react-router-dom';
import RequireAuth from '@/components/auth/RequireAuth';
import AppLayout from '@/components/layout/AppLayout';

export const router = createBrowserRouter([
  {
    path: '/login',
    lazy: () =>
      import('@/features/auth/LoginPage').then((m) => ({ Component: m.default })),
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/portfolio" replace /> },
      {
        path: 'portfolio',
        lazy: () =>
          import('@/features/projects/PortfolioPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'projects/:id',
        lazy: () =>
          import('@/features/projects/ProjectCardPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'reports',
        lazy: () =>
          import('@/features/reports/BatchReportPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'roadmap',
        lazy: () =>
          import('@/features/roadmap/RoadmapPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'risks',
        lazy: () =>
          import('@/features/risks/RisksPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'tasks',
        lazy: () =>
          import('@/features/tasks/TasksPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'finance',
        lazy: () =>
          import('@/features/team/TeamAnalyticsPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'presale',
        lazy: () =>
          import('@/features/presale/PresalePage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'workload',
        lazy: () =>
          import('@/features/workload/WorkloadPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'settings',
        lazy: () =>
          import('@/features/settings/SettingsPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'dashboard',
        lazy: () =>
          import('@/features/dashboard/DashboardPage').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: '*',
        element: <Navigate to="/portfolio" replace />,
      },
    ],
  },
]);
